<p-field
    [isMandatory]="required | booleanTransform"
    [label]="label"
    [labelTooltip]="labelTooltip"
    [isReadOnly]="isReadOnly"
    [isDisable]="isDisabled"
    [customClasses]="getCustomClasses()"
    [shouldTransformLabelTextCase]="shouldTransformLabelTextCase"
    [actionIconName]="actionIconName"
    [actionIconUrl]="actionIconUrl"
    [actionIconTooltip]="actionIconTooltip"
    (actionIconClicked)="actionIconClicked.emit()"
>
    <div slot="editMode" class="p-edit-mode-wrapper">
        <mat-form-field [class]="getFormFieldClasses()" [class.error]="shouldShowError" appearance="outline" floatLabel="always">
            <div class="p-mat-field-content" *ngIf="!isMultiline">
                <input
                    matInput
                    #pInput
                    #inputName="matInput"
                    class="p-input-text-input ellipsis"
                    [name]="type === 'password' ? 'password' : ''"
                    [autocomplete]="type === 'password' ? 'new-password' : 'off'"
                    [type]="type"
                    [value]="valueAccessor.value"
                    [placeholder]="(placeholder | sentenceCase) || placeholderText"
                    [showOnlyWhenEllipsis]="true"
                    [disableTooltip]="type === 'password'"
                    [matTooltip]="type === 'password' ? '' : inputTooltip"
                    [attr.automation-id]="automationId"
                    [attr.aria-label]="ariaLabel"
                    [attr.maxlength]="maxLength ?? 255"
                    (focus)="pInput.select()"
                    (keyup)="shouldUpdateCursorPosition ? emitCursorPositionChange() : null; keyup.emit($event)"
                    (click)="shouldUpdateCursorPosition ? emitCursorPositionChange() : null"
                    (input)="onInput($event); shouldUpdateCursorPosition ? emitCursorPositionChange() : null"
                    (keyup.enter)="onEnterPressed($event)"
                    (change)="changeValue($event)"
                />
                <p-icon
                    *ngIf="iconName"
                    class="p-input-text-icon"
                    matSuffix
                    [name]="iconName"
                    [color]="iconColor"
                    width="16"
                    height="16"
                ></p-icon>
            </div>
            <div *ngIf="isMultiline">
                <div
                    [ngClass]="{
                        'multiline-expandable': isAutoResizable,
                        'p-text-area-border': isAiEnabled,
                        'ai-border-animation': isAIInProgress && isAiEnabled
                    }"
                >
                    <textarea
                        [ngStyle]="dynamicStyle"
                        matInput
                        [cdkTextareaAutosize]="isAutoResizable"
                        #pTextarea
                        #autosize="cdkTextareaAutosize"
                        [class.ai-enabled]="isAiEnabled"
                        [class]="'p-textarea-input p-field-text-paragraph ' + size"
                        autocomplete="off"
                        [cdkAutosizeMinRows]="autoSizeMinRows"
                        [cdkAutosizeMaxRows]="autoSizeMaxRows"
                        [attr.automation-id]="automationId"
                        [mentionConfig]="mentionCfg"
                        [placeholder]="(placeholder | sentenceCase) || placeholderText"
                        [value]="valueAccessor.value"
                        [attr.maxlength]="maxLength"
                        [readonly]="isReadOnly || isAIInProgress"
                        [attr.aria-label]="ariaLabel"
                        (itemSelected)="mentionAdded.emit($event)"
                        (focus)="pTextarea.select()"
                        (keyup)="shouldUpdateCursorPosition ? emitCursorPositionChange() : null"
                        (click)="shouldUpdateCursorPosition ? emitCursorPositionChange() : null"
                        (input)="changeValue($event); shouldUpdateCursorPosition ? emitCursorPositionChange() : null"
                        (keyup.escape)="onTextAreaEscapePressed($event)"
                        (keyup.enter)="onEnterPressed($event)"
                        (blur)="onBlurTextArea($event)"
                    ></textarea>
                    <div *ngIf="isAiEnabled" (click)="aiTriggered()" class="ai-btn" [attr.automation-id]="automationId + '_ai_btn'">
                        <img [src]="'assets/icons/svgs/ai-summarize.svg'" />
                        <span class="p-field-text-paragraph" [matTooltip]="aiTooltipKey | translate" matTooltipPosition="after">
                            {{ aiTextKey | translate }}
                        </span>
                    </div>
                </div>
                <p-expand-area-trigger
                    #expandAreaTrigger
                    *ngIf="isExpandable"
                    [element]="pTextarea"
                    (expandElement)="expandElement($event)"
                ></p-expand-area-trigger>
            </div>
        </mat-form-field>
        <div *ngIf="shouldShowError" class="error-message">
            {{ errorMessage }}
        </div>
    </div>

    <!-- read mode -->
    <mat-form-field slot="readMode" [class]="getFormFieldClasses()" appearance="outline" floatLabel="always">
        <input
            *ngIf="!isMultiline"
            matInput
            readonly
            class="p-input-text-input ellipsis"
            [attr.automation-id]="automationId"
            [disabled]="isDisabled"
            [type]="type"
            [value]="valueAccessor.value"
            [placeholder]="(placeholder | sentenceCase) || placeholderText"
            [attr.aria-label]="ariaLabel"
            [matTooltip]="type === 'password' ? '' : inputTooltip"
            [showOnlyWhenEllipsis]="true"
        />
        <div *ngIf="isMultiline" [ngClass]="{ 'multiline-expandable': isAutoResizable }">
            <textarea
                [readonly]="!isDisabled"
                [disabled]="isDisabled"
                matInput
                #pTextarea
                #autosize="cdkTextareaAutosize"
                [cdkTextareaAutosize]="isAutoResizable"
                [class]="'p-textarea-input p-field-text-paragraph ' + size"
                [cdkAutosizeMinRows]="autoSizeMinRows"
                [cdkAutosizeMaxRows]="autoSizeMaxRows"
                [attr.automation-id]="automationId"
                [placeholder]="(placeholder | sentenceCase) || placeholderText"
                [value]="valueAccessor.value"
                [attr.aria-label]="ariaLabel"
            ></textarea>
            <p-expand-area-trigger
                #expandAreaTrigger
                *ngIf="isExpandable"
                [element]="pTextarea"
                (expandElement)="expandElement($event)"
            ></p-expand-area-trigger>
        </div>
    </mat-form-field>
</p-field>
